import moment from "moment";
import "moment-duration-format";
import "moment-precise-range-plugin";
import { isTypeRelativeWithStartOnly } from "views/typeGuards/timeRange";
export const readableRange = (timerange, fieldName, placeholder = "All Time") => {
  const rangeAsSeconds = timerange == null ? void 0 : timerange[fieldName];
  if (!rangeAsSeconds) {
    return placeholder;
  }
  const reference = moment();
  const dateAgo = moment(reference).subtract(rangeAsSeconds, "seconds");
  const rangeTimespan = moment.preciseDiff(reference, dateAgo);
  return `${rangeTimespan} ago`;
};
const relativeTimeRangeToString = (timerange) => {
  if (isTypeRelativeWithStartOnly(timerange)) {
    if (timerange.range === 0) {
      return "All Time";
    }
    return `${readableRange(timerange, "range")} - Now`;
  }
  return `${readableRange(timerange, "from")} - ${readableRange(timerange, "to", "Now")}`;
};
const absoluteTimeRangeToString = (timerange, localizer = (dateTime) => dateTime) => {
  const { from, to } = timerange;
  return `${localizer(from)} - ${localizer(to)}`;
};
const keywordTimeRangeToString = (timerange) => timerange.keyword;
const TimeRangeToString = (timerange, localizer) => {
  const { type } = timerange || {};
  switch (type) {
    case "relative":
      return relativeTimeRangeToString(timerange);
    case "absolute":
      return absoluteTimeRangeToString(timerange, localizer);
    case "keyword":
      return keywordTimeRangeToString(timerange);
    default: {
      return "";
    }
  }
};
export default TimeRangeToString;
